import _ from "lodash";
import { getWorkflowItemTitle } from "WorkflowProgressMenu/modules/Utils";
import { formatDate } from "Utils";
import { WORKFLOW_CREATED_AT_FORMAT } from "Workflows/modules/Constants";

export const STEPS = {
  STEP_1: "STEP_1",
  STEP_2: "STEP_2",
};

export const fetchAndUpdateTitle = ({ jobs, t, activeWorkflowId = null }) => {
  let currentJob;
  if (activeWorkflowId) {
    currentJob = _.find(jobs, job => job.node.id === activeWorkflowId);
  } else {
    currentJob = _.first(jobs);
  }

  const createdAt = _.get(currentJob, "node.createdAt", "");
  const subtask = _.get(currentJob, "node.workflowProgress.subTaskData", {});
  const {
    workflowTaskOrgLevelLocaleKey,
    workflowTaskOrgLevelLocaleParams,
  } = _.get(subtask, "parsedData", {});

  return {
    [STEPS.STEP_1]: {
      title: getWorkflowItemTitle({
        t,
        locale: workflowTaskOrgLevelLocaleKey,
        localeParams: workflowTaskOrgLevelLocaleParams,
      }),
      subtitle: "",
    },
    [STEPS.STEP_2]: {
      title: formatDate({
        date: createdAt,
        format: WORKFLOW_CREATED_AT_FORMAT,
      }),
      subtitle: getWorkflowItemTitle({
        t,
        locale: workflowTaskOrgLevelLocaleKey,
        localeParams: workflowTaskOrgLevelLocaleParams,
      }),
    },
  };
};
